import type { FaireProductEntity } from "../../entity_types/product";

export const p_shgbups8vr: FaireProductEntity = {
  token: "p_shgbups8vr",
  type: "product",
  name: "Spicy Pineapple Peanut Dipping Sauce",
  brandToken: "b_gnxbv2hjdn",
  brandName: "Chin Dribblin' Specialty Asian Fusion Sauces",
  imageUrl:
    "https://cdn.faire.com/fastly/ade1502495cdc22bf2f1d46aa85df6b7ddc714a5880a99a1a0a255a9b364bbb7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6509f2b42ef6d2e67e0813c75ff989b33bb84c6bb6b4d2af041825a79d112893.jpeg",
    "https://cdn.faire.com/fastly/82b3dda8cbf5c493a44b16da05b0e54f97476f3b2d62dd126abf4dd90c2c033b.jpeg",
    "https://cdn.faire.com/fastly/330b826dc00b8808404c7af192985e93c3ecc8e7d3e6daee6da27b4dc36bde4e.jpeg",
    "https://cdn.faire.com/fastly/f6d41641a74f13b0acc55a9b5e850e70070ef6cf8686c6349035befd51ed110f.jpeg",
    "https://cdn.faire.com/fastly/a7b07721c15a3e79d6abfe40d767c6b27f91dbd152d85b990df4ce7495678b74.jpeg",
  ],
  priceDollars: 7.5,
  description:
    "\nThis rich, tangy and spicy sauce will pack a punch with a variety of different dishes! Try it with spring rolls, chicken satay, or veggies. Add it to a peanut curry, or make a peanut noodle bowl with it!\n\nFeatured on Gordon Ramsay's Food Stars\n\nCONTAINS: Peanuts, Soy, Sesame\n\nGluten Free, Vegan\n",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:17:11.532Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
